module.exports = __webpack_public_path__ + "static/img/topremen.50ee4fd7.png";